import React, { useContext, useEffect, useState } from "react";
import { showAlert } from "../../../../Services/Shared.service";
import { Card, CardBody, Row } from "reactstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  getPackageRatesListByPackId,
  getPackage,
} from "../../../../Services/Packages.service";
import { Button,IconButton, Tooltip } from "@mui/material";
import PackageRatesTable from "../Tables/PackageRatesTable";
import DriverPayoutsTable from "../Tables/DriverPayoutsTable";
import DriverCreditsTable from "../Tables/DriverCreditsTable";
import { useParams, useNavigate } from "react-router";
import { getAvatarText } from "../../../../Services/Shared.service";
import { H1 } from "../../../../AbstractElements";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PackageInput from "../../../Packages/PackageInput";
import SharedDataContext from "../../../../_helper/SharedData";
import editIcon from "../../../../assets/images/tarrifManagement/edit.png";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  Box,
  Paper,
  styled,
  Switch,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Skeleton,
} from "@mui/material";
import PackagesForms from "../../../FormsTariff/PackagesForms";
import CreateEditPackageDrawerForm from "../../../FormsTariff/CreateEditPackageDrawerForm";
import EditPackageRateForm from "../../../FormsTariff/EditPackageRateForm";
import CreatePackageRateFlow from "../../../CorprateClientsFlow/CreatePackageRateFlow.jsx";
import { useTariffSearch } from "../../../../_helper/TariffSearchContext/TariffSeachContext.jsx";
import { TABS_STYLE, TAB_ITEM_STYLE } from "../../../../styles/CommonStyles";
import { usePayoutAllowedCities } from "../../../../hooks/usePayoutAllowedCities";

function PackInfo() {
  const { cityData, taxData ,allCityData} = useContext(SharedDataContext);
  const {packageRateInputModal,setPackageRateInputModal} = useTariffSearch();
  const { packId } = useParams();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [packObj, setPackObj] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [corpObj, setCorpObj] = useState({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 30,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [packagesData, setPackagesData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const { isCityAllowed } = usePayoutAllowedCities(packObj?.serviceCityId);
  const isPayoutAndCreditAvailable = isCityAllowed;

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    fetchPackageObj();
  }, []);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const fetchPackageObj = () => {
    setLoading(true);
    let obj = {
      packageId: packId,
    };

    getPackage(obj)
      .then((resp) => {
        setPackObj(resp.data);
      })
      .catch((err) => {
        // showAlert("Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const CityName = {
    1: "Delhi",
    8: "Amritsar",
    30: "Chennai",
    32: "Goa",
    4: "Bangalore",
  };

  const handleOpenRateModal = () => {
    setPackageRateInputModal(true);
  };

  const handleCloseRateModal = () => {
      setPackageRateInputModal(false);
  };

  const getCarNameById = (carId) => {
    if (!Array.isArray(allCityData)) return "-";

    for (const city of allCityData) {
      const match = city?.carType?.find((car) => car.id === carId);
      if (match) return match.name;
    }

    return "-";
  };

  return (
    // <div
    //   style={{
    //     paddingTop: 40,
    //   }}
    // >
    //   <div
    //     style={{
    //       display: "flex",
    //       justifyContent: "left",
    //     }}
    //   >
    //     <Button
    //       startIcon={<ArrowBackIosIcon />}
    //       sx={{
    //         color: "#41CC7D",
    //         marginBottom: 2,
    //       }}
    //       onClick={handleBack}
    //     >
    //       Back
    //     </Button>
    //   </div>

    //   <Card className="driver-details">
    //     <CardBody
    //       style={{
    //         color: "whitesmoke",
    //       }}
    //     >
    //       <div className="dsp-flx">
    //         <H1>{packObj.name}</H1>
    //         <Tooltip title="Edit Packages">
    //           <IconButton size="large" onClick={() => setIsOpen(true)}>
    //             <EditNoteIcon sx={{ color: "#FFFF", width: 30, height: 30 }} />
    //           </IconButton>
    //         </Tooltip>
    //       </div>
    //       <table>
    //         <tr>
    //           <td>
    //             <td className="td-head">Service City </td>
    //             <td className="td-dtls">{CityName[packObj.serviceCityId]}</td>
    //           </td>
    //           <td>
    //             <td className="td-headrt">Initial Distance in Km</td>
    //             <td className="td-dtls">
    //               {packObj.initialDistanceKm ? packObj.initialDistanceKm : "-"}
    //             </td>
    //           </td>
    //         </tr>
    //         <tr>
    //           <td>
    //             <td className="td-head">Active </td>
    //             <td className="td-dtls">
    //               {packObj.isActive ? "True" : "False"}
    //             </td>
    //           </td>
    //           <td>
    //             <td className="td-headrt">Initial distance charge </td>
    //             <td className="td-dtls">
    //               {packObj.initialDistanceCharge
    //                 ? packObj.initialDistanceCharge
    //                 : "-"}
    //             </td>
    //           </td>
    //         </tr>

    //         <tr>
    //           <td>
    //             <td className="td-head">Auto Rollover </td>
    //             <td className="td-dtls">
    //               {packObj.autoRollover ? "True" : "False"}
    //             </td>
    //           </td>
    //           <td>
    //             <td className="td-headrt">Per km charge </td>
    //             <td className="td-dtls">
    //               {packObj.perKmCharge ? packObj.perKmCharge : "-"}
    //             </td>
    //           </td>
    //         </tr>

    //         <tr>
    //           <td>
    //             <td className="td-head">Airport Express </td>
    //             <td className="td-dtls">
    //               {packObj.isAirportExpress ?  "True" : "False"}
    //             </td>
    //           </td>

    //           <td>
    //             <td className="td-headrt">Toll amount </td>
    //             <td className="td-dtls">
    //               {packObj.tollAmount ? packObj.tollAmount : "-"}
    //             </td>
    //           </td>
    //         </tr>

    //         <tr>
    //           <td>
    //             <td className="td-head">Tax </td>
    //             <td className="td-dtls">
    //               {`Base ${
    //                  packObj?.baseFareTaxId === 18
    //                   ? "12%"
    //                   : "0%"

    //               } Service ${
    //                 packObj?.serviceTaxId === 18
    //                   ? "12%"
    //                   : "0%"
    //               }`}
    //             </td>
    //           </td>
    //         </tr>
    //       </table>
    //     </CardBody>
    //   </Card>
    //   <div>
    //     <PackageRatesTable packId={packId} />
    //   </div>
    //   <PackageInput
    //     isOpen={isOpen}
    //     cityData={cityData}
    //     editId={packId}
    //     toggleModal={toggleModal}
    //   />
    // </div>
    <div style={{}}>
      <div
        style={{
          display: "flex",
          justifyContent: "left",
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon />}
          sx={{
            color: "#41CC7D",
            marginBottom: 2,
          }}
          onClick={handleBack}
        >
          Back
        </Button>
      </div>

      <Card className="clientInfoCard">
        <CardBody
          style={{
            // color: "whitesmoke",
            backgroundColor: "rgba(20, 152, 38, 0.9)",
            borderRadius: "10px",
            boxShadow: `inset 0 0 8px white,inset 0 0 4px white`,
            border: "1px solid rgba(116, 206, 106, 1)",
          }}
        >
          {loading ? (
            <Box sx={{ marginX: "10px", marginTop: "0.69vw" }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "auto",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <Skeleton variant="text" width={200} height={40} />
                    <Skeleton variant="rounded" width={80} height={30} />
                  </Box>
                  <Box>
                    <Skeleton variant="circular" width={30} height={30} />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ width: "70%", marginTop: "30px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  {[1, 2, 3, 4].map((i) => (
                    <Box key={i} sx={{ flex: "1" }}>
                      <Skeleton variant="text" width={80} />
                      <Skeleton variant="text" width={100} height={30} />
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "40px",
                  }}
                >
                  {[1, 2, 3, 4].map((i) => (
                    <Box key={i} sx={{ flex: "1" }}>
                      <Skeleton variant="text" width={80} />
                      <Skeleton variant="text" width={100} height={30} />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ) : (
            <Box sx={{ marginX: "10px", marginTop: "0.69vw" }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    // border: "1px solid red",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "auto",
                      // border: "1px solid red",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.67vw",
                        color: "#ffffff",
                        fontWeight: "600",
                      }}
                    >
                      {packObj.name}
                    </Typography>
                    {packObj.isActive ? (
                      <Box
                        sx={{
                          display: "flex",
                          backgroundColor: "#E3F5E1",
                          width: "6.11vw",
                          height: "2.01vw",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          borderRadius: "6px",
                          padding: "6px",
                          border: "2px solid rgba(116, 206, 106, 1)",
                          // height: "2.01vw",
                        }}
                      >
                        <Box
                          sx={{
                            width: "0.56vw",
                            height: "0.56vw",
                            background: "rgba(116, 206, 106, 1)",
                            borderRadius: "50%",
                          }}
                        />
                        <Typography sx={{ fontSize: "0.97vw" }}>
                          Active
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-around",
                          width: "6.11vw",
                          height: "2.01vw",
                          borderRadius: "6px",
                          padding: "6px",
                          backgroundColor: "#ffe5e5", // light red
                          border: "1px solid #cc0000", // darker red border
                        }}
                      >
                        <Box
                          sx={{
                            width: "0.56vw",
                            height: "0.56vw",
                            backgroundColor: "#cc0000",
                            borderRadius: "50%",
                          }}
                        />
                        <Typography
                          sx={{ fontSize: "0.97vw", color: "#cc0000" }}
                        >
                          InActive
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <img
                      src={editIcon}
                      alt="edit"
                      style={{
                        width: "1.75vw",
                        height: "1.61vw",
                        cursor: "pointer",
                      }}
                      onClick={() => setIsDrawerOpen(true)}
                    />
                    <Tooltip title="Create Package Rate">
                      <IconButton
                        size="large"
                        onClick={() => handleOpenRateModal()}
                      >
                        <AddCircleIcon
                          sx={{ color: "#FFFF", width: "2.08vw", height: "2.08vw" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ width: "70%", marginTop: "30px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Service City
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj?.serviceCityName}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Auto Rollover
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj.autoRollover ? "Yes" : "No"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Airport Express
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj.isAirportExpress ? "Yes" : "No"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Available On
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj.isKiosk ? "Kiosk" : "TMS"}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "40px",
                  }}
                >
                  <Box width={"8.82vw"} sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Initial Distance(Km)
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj.initialDistance ?? "0"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Initial Distance Charge
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                     {packObj.initialDistanceCharge ?? "0"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Per Km Charge
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj.perKmCharge ?? "0"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: "1" }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Toll Amount
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {packObj.tollAmount ?? "0"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </CardBody>
      </Card>
      <div>
        {isPayoutAndCreditAvailable ? (
          <Box sx={{ mt: 2 }}>
            <Tabs value={activeTab} onChange={handleTabChange} sx={TABS_STYLE}>
              <Tab label="Package Rates" sx={TAB_ITEM_STYLE} disableRipple />
              <Tab label="Driver Payouts" sx={TAB_ITEM_STYLE} disableRipple />
              <Tab label="Driver Credits" sx={TAB_ITEM_STYLE} disableRipple />
            </Tabs>

            {activeTab === 0 && (
              <PackageRatesTable packId={packId} selectedPackage={packObj} />
            )}
            {activeTab === 1 && <DriverPayoutsTable packId={packId} serviceCityId={packObj?.serviceCityId} />}
            {activeTab === 2 && <DriverCreditsTable packId={packId} />}
          </Box>
        ) : (
          !isPayoutAndCreditAvailable && (
            <div>
              <PackageRatesTable packId={packId} selectedPackage={packObj} />
            </div>
          )
        )}
      </div>     
      <CreateEditPackageDrawerForm
        title="Edit Packages"
        isOpen={isDrawerOpen}
        setIsOpen={setIsDrawerOpen}
        editId={packId}
        fetchTableData={fetchPackageObj}
      />

      {/* <CreateCorpFlow
        packObj={packObj}
        isOpen={isCreate}
        handleCloseModal={handleCloseModal}
      />  */}
      <CreatePackageRateFlow
        isOpen={packageRateInputModal}
        handleCloseModal={handleCloseRateModal}
        corpObj={packObj}
      />
    </div>
  );
}

export default PackInfo;
